import { render } from "./UserRoleDetails.vue?vue&type=template&id=616eb08d&scoped=true"
import script from "./UserRoleDetails.vue?vue&type=script&lang=js"
export * from "./UserRoleDetails.vue?vue&type=script&lang=js"

import "./UserRoleDetails.vue?vue&type=style&index=0&id=616eb08d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616eb08d"]])

export default __exports__